import { useMutation } from "@tanstack/react-query";
import { ActivationPackService } from "@/services/database/ActivationPackService";
import { ActivationPackWithTarget } from "@/types/activation/activation-pack";

export interface ActivateCustomersResult {
  sent: number;
  notSent: number;
  unknown: number;
}

/**
 * The single "activate my customers" action — one combined email per
 * recipient covering the activation presentation, the app smart link, and
 * (for agent-backed packs) a working Genie access link. No dashboard access
 * is granted — this is for reaching customers, not adding HelpGenie users.
 */
export const useActivateCustomers = (
  pack: ActivationPackWithTarget | null | undefined,
) =>
  useMutation({
    mutationFn: async ({
      emails,
      campaignId,
    }: {
      emails: string[];
      campaignId: string;
    }): Promise<ActivateCustomersResult> => {
      if (!pack) throw new Error("No activation pack");

      const results = await ActivationPackService.activateCustomers(
        pack.id,
        emails,
        campaignId,
      );

      return {
        sent: results.filter((r) => r.sent).length,
        notSent: results.filter((r) => r.state === "not_sent").length,
        unknown: results.filter((r) => r.state === "unknown").length,
      };
    },
  });
